import { render } from "./SalesBaitManagement.vue?vue&type=template&id=6137dcfc&scoped=true"
import script from "./SalesBaitManagement.vue?vue&type=script&lang=js"
export * from "./SalesBaitManagement.vue?vue&type=script&lang=js"

import "./SalesBaitManagement.vue?vue&type=style&index=0&id=6137dcfc&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6137dcfc"]])

export default __exports__